export function hoverTeamCard() {
	const $block = $(".team-card");
	const BODY = $("body");
	const WIN = $(window);
	const point = 1200;
	setEvents();
	function setEvents() {
		$block.hover(
			function () {
				if (BODY.hasClass("no-touch") && WIN.width() > point) {
					$(this).find('.content-bottom').slideDown(300);
				}
			},
			function () {
				$(this).find('.content-bottom').slideUp(300);
			}
		);
	}
}


// WEBPACK FOOTER //
// ./assets/js/modules/hoverTeamCard.js